import { Check, OpenInNewRounded } from "@mui/icons-material";
import { alpha, darken, lighten, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import { formatIsoDateString, isValidUUID } from "../../utils/helpers";
import OmniAvatar from "./omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const OmniUserAssessmentListItem = props => {
  const { assessmentODM, onClickHandler = null } = props;
  const theme = useTheme();

  const getAssessmentStatus = assessment => {
    if (assessment.omniData.completeDate != null) {
      return `Completed: ${formatIsoDateString(assessment.omniData.completeDate)}`;
    }
    if (assessment.omniData.startDate != null) {
      return `Started: ${formatIsoDateString(assessment.omniData.startDate)}`;
    }
    return "Not Started";
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler(assessmentODM);
        }
      }}
    >
      {isValidUUID(assessmentODM._id) && (
        <Tooltip title={"No Notes"} placement="right">
          {Object.prototype.toString.call(assessmentODM.omniData.assessmentResults) ===
          "[object Object]" ? (
            <OmniAvatar
              sx={[
                {
                  width: 36,
                  height: 36,
                  fontSize: "1.8rem",
                  boxShadow: theme.shadows[1],
                  cursor: "unset",
                },
                assessmentODM.omniData.assessmentResults.finalResult.toString().length >= 3 && {
                  fontSize: "1.4rem",
                },
                assessmentODM.omniData.assessmentResults.finalResult.toString().length >= 4 && {
                  fontSize: "1.2rem",
                },
                assessmentODM.omniData.assessmentResults.finalResult >= 14 && {
                  color: darken(theme.palette.error.main, 0.5),
                  backgroundColor: lighten(theme.palette.error.main, 0.5),
                  border: `2px solid ${darken(theme.palette.error.main, 0.5)}`,
                },
                assessmentODM.omniData.assessmentResults.finalResult > 6 &&
                  assessmentODM.omniData.assessmentResults.finalResult < 14 && {
                    color: darken(theme.palette.warning.main, 0.5),
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${darken(theme.palette.warning.main, 0.5)}`,
                  },
                assessmentODM.omniData.assessmentResults.finalResult <= 6 && {
                  color: darken(theme.palette.success.main, 0.5),
                  backgroundColor: lighten(theme.palette.success.main, 0.5),
                  border: `2px solid ${darken(theme.palette.success.main, 0.5)}`,
                },
                (assessmentODM.omniData.omniType === constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType ===
                    constants.assessmentIDs.omniHealthHistory) && {
                  color: darken(theme.palette.success.main, 0.5),
                  backgroundColor: lighten(theme.palette.success.main, 0.5),
                  border: `2px solid ${darken(theme.palette.success.main, 0.5)}`,
                },
              ]}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              {assessmentODM.omniData.omniType === constants.ar1001Prescreen ||
              assessmentODM.omniData.omniType === constants.assessmentIDs.omniHealthHistory ? (
                <Check />
              ) : (
                assessmentODM.omniData.assessmentResults.finalResult
              )}
            </OmniAvatar>
          ) : (
            <OmniAvatar
              sx={[
                {
                  width: 36,
                  height: 36,
                  fontSize: "1.8rem",
                  boxShadow: theme.shadows[1],
                  cursor: "unset",
                },
                (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType !== constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults
                    .find(scoringMethod => scoringMethod.isDefault === true)
                    .finalResult.toString().length >= 3 && {
                    fontSize: "1.4rem",
                  },
                (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType !== constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults
                    .find(scoringMethod => scoringMethod.isDefault === true)
                    .finalResult.toString().length >= 4 && { fontSize: "1.2rem" },
                (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType !== constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults.find(
                    scoringMethod => scoringMethod.isDefault === true,
                  ).finalResult >= 14 && {
                    color: darken(theme.palette.error.main, 0.5),
                    backgroundColor: lighten(theme.palette.error.main, 0.5),
                    border: `2px solid ${darken(theme.palette.error.main, 0.5)}`,
                  },
                (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType !== constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults.find(
                    scoringMethod => scoringMethod.isDefault === true,
                  ).finalResult > 6 &&
                  (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                    assessmentODM.omniData.omniType !==
                      constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults.find(
                    scoringMethod => scoringMethod.isDefault === true,
                  ).finalResult < 14 && {
                    color: darken(theme.palette.warning.main, 0.5),
                    backgroundColor: lighten(theme.palette.warning.main, 0.5),
                    border: `2px solid ${darken(theme.palette.warning.main, 0.5)}`,
                  },
                (assessmentODM.omniData.omniType !== constants.ar1001Prescreen ||
                  assessmentODM.omniData.omniType !== constants.assessmentIDs.omniHealthHistory) &&
                  assessmentODM.omniData.assessmentResults.find(
                    scoringMethod => scoringMethod.isDefault === true,
                  ).finalResult <= 6 && {
                    color: darken(theme.palette.success.main, 0.5),
                    backgroundColor: lighten(theme.palette.success.main, 0.5),
                    border: `2px solid ${darken(theme.palette.success.main, 0.5)}`,
                  },
              ]}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              {
                assessmentODM.omniData.assessmentResults.find(
                  scoringMethod => scoringMethod.isDefault === true,
                ).finalResult
              }
            </OmniAvatar>
          )}
        </Tooltip>
      )}
      <ListItemText
        primary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.commonground.contrastText,
              marginTop: 0,
            }}
          >
            {getAssessmentStatus(assessmentODM)}
          </Typography>
        }
        secondary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.commonground.contrastText,
              minimumHeight: 20,
            }}
          >
            {assessmentODM.omniData.title}
          </Typography>
        }
      />

      <OmniListItemButton
        title={"View Results"}
        sx={[
          {
            marginTop: "1px",
            marginRight: "1px",
            "& .MuiSvgIcon-root": {
              fill: alpha(theme.palette.secondary.main, 0.75),
            },
            "&:hover, :active": {
              transform: "scale(1.095)",
              background: alpha(theme.palette.secondary.main, 0.15),
              "& .MuiSvgIcon-root": {
                fill: theme.palette.secondary.main,
              },
            },
          },
        ]}
        size="large"
        onClick={e => {
          e.stopPropagation();
          onClickHandler(assessmentODM);
        }}
        icon={<OpenInNewRounded />}
      />
    </ListItem>
  );
};

export default OmniUserAssessmentListItem;
